import React from "react";

type ClientServicePreferencesIndicatorProps = {
  tooltip: string;
  ariaLabel: string;
  className?: string;
  preview?: string | null;
};

/**
 * Distinct from notes (sticky-note / warning) and tags (chips).
 * Uses sparkles + info color for structured prefs (GAP-F2-065).
 */
const ClientServicePreferencesIndicator: React.FC<
  ClientServicePreferencesIndicatorProps
> = ({
  tooltip,
  ariaLabel,
  className = "ri-sparkling-2-line text-primary ms-1 flex-shrink-0",
  preview,
}) => {
  return (
    <span
      className="d-inline-flex align-items-center gap-1"
      title={tooltip}
      aria-label={ariaLabel}
    >
      <i className={className} aria-hidden="true" />
      {preview && preview !== "★" ? (
        <span
          className="text-primary small text-truncate"
          style={{ maxWidth: 120 }}
          data-clarity-mask="true"
        >
          {preview}
        </span>
      ) : null}
    </span>
  );
};

export default ClientServicePreferencesIndicator;
